import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

const SERVICE_NAME = "CoeBidStaffService.asmx";

@Injectable({
  providedIn: "root",
})
export class CoeBidStaffService {
  constructor(private http: HttpUtilService) {}

  getByIc(bidderIc: string): Observable<any> {
    const encodedBidderIc = encodeURIComponent(`"${bidderIc}"`);
    return this.http.get(`/${SERVICE_NAME}/GetByIc?bidderIc=${encodedBidderIc}`);
  }

  addRecord(model: any): Observable<any> {
    const payload = {
      model: {
        __type: "KAPS.Model.CrmKomocoUser",
        ...model
      }
    };
    return this.http.post(`/${SERVICE_NAME}/AddRecord`, payload);
  }
  
  updateRecord(model: any): Observable<any> {
    const payload = {
      model: {
        __type: "KAPS.Model.CrmKomocoUser",
        ...model
      }
    };
    return this.http.post(`/${SERVICE_NAME}/UpdateRecord`, payload);
  }
  
  delete(bidderIc: string): Observable<any> {
    const payload = { bidderIc };
    return this.http.post(`/${SERVICE_NAME}/Delete`, payload);
  }
  
  getCOEBidStaffReport(): Observable<any> {
    return this.http.get(`/${SERVICE_NAME}/GetCOEBidStaffReport`);
  }
  

}